import React from "react";
import { Demo } from "./page";

export const demo = () => [
    {
        target: "$ONE_LAYOUT_ROUTE",
        handler: {
            exact: true,
            path: `/demo`,
            element: <Demo />
        }
    }
];
